import { render } from "./WorksDetailPage.vue?vue&type=template&id=65d34542&scoped=true"
import script from "./WorksDetailPage.vue?vue&type=script&lang=js"
export * from "./WorksDetailPage.vue?vue&type=script&lang=js"

import "./WorksDetailPage.vue?vue&type=style&index=0&id=65d34542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d34542"]])

export default __exports__